const SITE_URL = (process.env.VUE_APP_SITE_URL || 'https://codeac.com.cn').replace(/\/+$/, '')
const DEFAULT_OG_IMAGE = `${SITE_URL}/favicon.svg`

const DEFAULT_SEO = {
  title: 'CodeAC - 信息学竞赛与算法学习平台',
  description:
    'CodeAC 提供算法题库、在线评测、课程活动、题单训练、知识分享与问答社区，帮助学习者系统提升编程与竞赛能力。',
  keywords: 'CodeAC,信息学竞赛,算法,在线评测,编程训练,OI,NOI,题库,题单,课程',
}

const ROUTE_SEO_RULES = [
  {
    test: (path) => path === '/',
    title: 'CodeAC - 信息学竞赛与算法学习平台',
    description:
      '在 CodeAC 参加活动课程、练习算法题库、完成专题题单并参与社区问答，建立稳定高效的编程学习闭环。',
    keywords: 'CodeAC,信息学竞赛,算法题库,在线评测,课程活动,题单训练',
    ogType: 'website',
  },
  {
    test: (path) => path === '/activity',
    title: '活动课程 - CodeAC',
    description: '查看 CodeAC 活动课程与报名信息，结合讲解与练习题单高效提升算法能力。',
    keywords: '活动课程,算法课程,编程课程,CodeAC',
  },
  {
    test: (path) => /^\/activity\/[^/]+$/.test(path),
    title: '课程详情 - CodeAC',
    description: '查看课程介绍、配套题目、资源与排行榜，持续跟进学习进度。',
    keywords: '课程详情,课程题目,算法练习,CodeAC',
  },
  {
    test: (path) => path === '/problem',
    title: '题库 - CodeAC',
    description: '在 CodeAC 题库按难度和标签筛选题目，随时提交代码并复盘解题思路。',
    keywords: '算法题库,在线刷题,在线评测,编程题,CodeAC',
  },
  {
    test: (path) => /^\/problem\/[^/]+$/.test(path),
    title: '题目详情 - CodeAC',
    description: '查看题目描述并在线提交代码，结合提交记录和题解完成高质量复盘。',
    keywords: '题目详情,在线提交,算法复盘,CodeAC',
    ogType: 'article',
  },
  {
    test: (path) => path === '/training',
    title: '题单列表 - CodeAC',
    description: '通过专题题单进行连续训练，覆盖不同难度与知识点。',
    keywords: '题单训练,算法专题,编程练习,CodeAC',
  },
  {
    test: (path) => /^\/training\/[^/]+$/.test(path),
    title: '题单详情 - CodeAC',
    description: '查看题单内容、排名与学习进度，形成可持续训练节奏。',
    keywords: '题单详情,题单排名,算法训练,CodeAC',
  },
  {
    test: (path) => path === '/contest',
    title: '比赛列表 - CodeAC',
    description: '浏览近期比赛并参与实战，检验阶段学习成果。',
    keywords: '算法比赛,编程竞赛,在线比赛,CodeAC',
  },
  {
    test: (path) => /^\/contest\/[^/]+$/.test(path),
    title: '比赛详情 - CodeAC',
    description: '查看比赛规则、题目与排行榜，进行阶段性能力评估。',
    keywords: '比赛详情,比赛题目,比赛排名,CodeAC',
  },
  {
    test: (path) => path === '/knowledge',
    title: '知识分享 - CodeAC',
    description: '阅读与发布编程学习内容，沉淀个人知识体系。',
    keywords: '知识分享,算法文章,学习笔记,CodeAC',
  },
  {
    test: (path) => path.startsWith('/discussion'),
    title: '问答区 - CodeAC',
    description: '在问答区提问、回答与讨论，快速解决学习卡点。',
    keywords: '编程问答,算法讨论,学习社区,CodeAC',
  },
  {
    test: (path) => path === '/blog',
    title: '文章列表 - CodeAC',
    description: '浏览 CodeAC 社区文章，学习题解、方法与经验总结。',
    keywords: '算法博客,题解文章,编程分享,CodeAC',
  },
  {
    test: (path) => /^\/blog\/[^/]+$/.test(path),
    title: '文章详情 - CodeAC',
    description: '查看社区文章内容并参与互动，沉淀可复用的学习方法。',
    keywords: '文章详情,学习经验,算法题解,CodeAC',
    ogType: 'article',
  },
  {
    test: (path) => path === '/exam-pack',
    title: '考试题单 - CodeAC',
    description: '浏览考试题单并进行模拟作答，提升实战能力。',
    keywords: '考试题单,模拟考试,编程测评,CodeAC',
  },
  {
    test: (path) => /^\/exam-pack\/[^/]+$/.test(path),
    title: '考试作答 - CodeAC',
    description: '进入考试题单详情完成作答并追踪成绩表现。',
    keywords: '考试作答,题单详情,编程考试,CodeAC',
  },
  {
    test: (path) => path === '/404',
    title: '页面不存在 - CodeAC',
    description: '访问的页面不存在，请返回首页继续学习。',
    keywords: '404,页面不存在,CodeAC',
    robots: 'noindex, nofollow',
  },
]

const NOINDEX_PREFIXES = ['/admin', '/user', '/login', '/register', '/reset', '/message']
const NOINDEX_PATTERNS = [
  /\/submission(\/|$)/,
  /\/wxpay(\/|$)/,
  /^\/blog\/new$/,
  /^\/blog\/edit\//,
]

const trimTrailingSlash = (path) => {
  if (!path || path === '/') {
    return '/'
  }
  return path.replace(/\/+$/, '')
}

const ensureLeadingSlash = (path) => {
  if (!path) {
    return '/'
  }
  return path.startsWith('/') ? path : `/${path}`
}

const resolveRouteSeo = (path) => ROUTE_SEO_RULES.find((rule) => rule.test(path))

const shouldNoIndex = (path) => {
  if (NOINDEX_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`))) {
    return true
  }
  return NOINDEX_PATTERNS.some((pattern) => pattern.test(path))
}

const upsertMeta = (attrName, attrValue, content) => {
  if (!content) {
    return
  }
  let element = document.head.querySelector(`meta[${attrName}="${attrValue}"]`)
  if (!element) {
    element = document.createElement('meta')
    element.setAttribute(attrName, attrValue)
    document.head.appendChild(element)
  }
  element.setAttribute('content', content)
}

const upsertLink = (rel, href) => {
  let element = document.head.querySelector(`link[rel="${rel}"]`)
  if (!element) {
    element = document.createElement('link')
    element.setAttribute('rel', rel)
    document.head.appendChild(element)
  }
  element.setAttribute('href', href)
}

const upsertJsonLd = (id, data) => {
  let script = document.head.querySelector(`script#${id}`)
  if (!script) {
    script = document.createElement('script')
    script.setAttribute('id', id)
    script.setAttribute('type', 'application/ld+json')
    document.head.appendChild(script)
  }
  script.text = JSON.stringify(data)
}

const inferOgType = (path, explicitType) => {
  if (explicitType) {
    return explicitType
  }
  if (/^\/(blog|problem)\/[^/]+$/.test(path)) {
    return 'article'
  }
  return 'website'
}

export const stripMarkdown = (raw = '') => {
  if (!raw || typeof raw !== 'string') {
    return ''
  }
  return raw
    .replace(/```[\s\S]*?```/g, ' ')
    .replace(/`[^`]*`/g, ' ')
    .replace(/!\[[^\]]*]\([^)]+\)/g, ' ')
    .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
    .replace(/<[^>]*>/g, ' ')
    .replace(/#+\s/g, ' ')
    .replace(/\*\*|__|\*|_|~~/g, ' ')
    .replace(/>\s?/g, ' ')
    .replace(/\r?\n/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}

export const truncateText = (text = '', maxLength = 160) => {
  if (!text || typeof text !== 'string') {
    return ''
  }
  if (text.length <= maxLength) {
    return text
  }
  return `${text.slice(0, Math.max(0, maxLength - 1)).trim()}…`
}

export const applyRouteSeo = (route = {}) => {
  if (typeof document === 'undefined') {
    return
  }

  const rawPath = route.path || window.location.pathname || '/'
  const path = trimTrailingSlash(rawPath)
  const meta = route.meta || {}
  const routeSeo = resolveRouteSeo(path) || {}

  const title = meta.seoTitle || routeSeo.title || meta.title || DEFAULT_SEO.title
  const description = meta.seoDescription || routeSeo.description || DEFAULT_SEO.description
  const keywords = meta.seoKeywords || routeSeo.keywords || DEFAULT_SEO.keywords
  const robots = meta.robots || routeSeo.robots || (shouldNoIndex(path) ? 'noindex, nofollow' : 'index, follow')
  const canonicalPath = trimTrailingSlash(ensureLeadingSlash(meta.canonicalPath || path))
  const canonicalUrl = `${SITE_URL}${canonicalPath === '/' ? '/' : canonicalPath}`
  const ogType = meta.ogType || inferOgType(path, routeSeo.ogType)
  const ogImage = meta.ogImage || DEFAULT_OG_IMAGE

  document.title = title
  upsertMeta('name', 'description', description)
  upsertMeta('name', 'keywords', keywords)
  upsertMeta('name', 'robots', robots)

  upsertMeta('property', 'og:type', ogType)
  upsertMeta('property', 'og:site_name', 'CodeAC')
  upsertMeta('property', 'og:locale', 'zh_CN')
  upsertMeta('property', 'og:title', title)
  upsertMeta('property', 'og:description', description)
  upsertMeta('property', 'og:url', canonicalUrl)
  upsertMeta('property', 'og:image', ogImage)

  upsertMeta('name', 'twitter:card', 'summary_large_image')
  upsertMeta('name', 'twitter:title', title)
  upsertMeta('name', 'twitter:description', description)
  upsertMeta('name', 'twitter:image', ogImage)

  upsertLink('canonical', canonicalUrl)

  const structuredData = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebSite',
        name: 'CodeAC',
        url: SITE_URL,
        inLanguage: 'zh-CN',
        description: DEFAULT_SEO.description,
        potentialAction: {
          '@type': 'SearchAction',
          target: `${SITE_URL}/problem?keyword={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'WebPage',
        name: title,
        url: canonicalUrl,
        inLanguage: 'zh-CN',
        description,
        isPartOf: {
          '@type': 'WebSite',
          name: 'CodeAC',
          url: SITE_URL,
        },
      },
    ],
  }

  if (canonicalPath === '/') {
    structuredData['@graph'].push({
      '@type': 'Organization',
      name: 'CodeAC',
      url: SITE_URL,
      logo: `${SITE_URL}/favicon.svg`,
    })
  }

  const customStructuredData = meta.structuredData
  if (Array.isArray(customStructuredData)) {
    structuredData['@graph'].push(...customStructuredData.filter(Boolean))
  } else if (customStructuredData) {
    structuredData['@graph'].push(customStructuredData)
  }

  upsertJsonLd('codeac-route-ldjson', structuredData)
}
